import React from "react";
import { Link } from "react-router-dom";
import {FaFacebookF, FaWhatsapp, FaInstagram, FaTwitter} from 'react-icons/fa'
import imo from '../../assets/imo.png'
const Footer = () => {
  return (
    <footer>
      <div className="footerContaner">
        <div className="footerLogo"><p>Sweets Wala</p></div>
        <div className="navlinks">
          <Link to='/about'>About</Link>
          <Link to='/contact'>Contact</Link>
          <Link to='/cart'>Cart</Link>
        </div>
        <div className="socialLinksContainer">
          <h1>Stay in touch</h1>
          <div className="socialLinks">
            <FaFacebookF/>
            <FaWhatsapp/>
            <a href="#"><img src={imo} alt="imo" /></a>
            <FaInstagram/>
            <FaTwitter/>
          </div>
        </div>
        <p>© 2022 Sweets-Wala from Fonoon</p>
      </div>
    </footer>
  );
};

export default Footer;
